import React, { Component } from 'react';
import {
  CssBaseline,
  Grid,
  makeStyles,
  TableBody,
  TableCell,
  TableHead,
  TableRow as MaterialTableRow,
  Typography,
  withStyles,
} from '@material-ui/core';

import cloneDeep from 'lodash/cloneDeep';

import axiosInstance, { WEB_API, getEventId } from '../../constatns';
import AdminTopbar from '../AdminTopbar';
import AdminFooter from '../AdminFooter';
import { CountryList } from '../../common/CountryList';
import SubTitle from '../../components/Text/SubTitle';
import Table from '../../components/Table/Table';

const styles = (theme) => ({
  root: {
    minHeight: 800,
    overflow: 'auto',
    '& .MuiPaper-root': {
      boxShadow: 'none',
      border: '1px solid rgba(224, 224, 224, 1)',
    },
    '& .MuiTableCell-root': {
      textAlign: 'center',
      fontSize: '13px',
      // minWidth: 100,
      '& span': {
        display: 'block',
        wordBreak: 'keep-all',
      },
      '& button': {
        fontSize: '13px',
      },
    },
    '& > div:not(:first-child)': {
      marginBottom: '30px',
    },
  },
  subTitle: {
    fontSize: '1.2em',
    fontWeight: 600,
    paddingLeft: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
});

const TableRow = withStyles((theme) => ({
  root: {
    '& > th:not(:last-of-type)': {
      borderRight: '1px solid rgba(224, 224, 224, 0.5)',
    },
    '& > td:not(:last-of-type)': {
      borderRight: '1px solid rgba(224, 224, 224, 0.5)',
    },
  },
}))(MaterialTableRow);

class MemberStatusTemp extends Component {
  constructor(props) {
    super(props);

    this.state = {
      count: {
        total: 0,
        korean: 0,
        international: 0,
      },
      byMemberKind: {
        private: 0,
        trainee: 0,
        general: 0,
        opening: 0,
        surgeon: 0,
        resident: 0,
        foreigner: 0,
        partner: 0,
      },
      byCountry: [],
    };
  }

  componentDidMount() {
    this.init();
  }

  init() {
    axiosInstance.get(`${WEB_API}/user/list?eventId=${getEventId()}&limit=-1`, { headers: { Pragma: 'no-cache' } }).then((response) => {
      /*
          // 등록자(isPay 값이 R)만 확인
          for (let item of response.data.Items) {
            if (item.isPay === 'R') {
              console.log(item);
            }
          }
        */
      // console.log('member', response.data);

      if (response.data.Items) {
        this.getData(response.data.Items);
      }
    });
  }

  getData(d) {
    let countTemp = this.getCountData(d);
    let countryTemp = this.getCountryData(d);
    let memberTemp = this.getMemberData(d);

    this.setState((prev) => ({
      count: countTemp,
      byCountry: countryTemp,
      byMemberKind: memberTemp,
    }));
  }

  // 총 등록자 수
  getCountData(d) {
    let buff = cloneDeep(this.state.count);
    d.map((item) => {
      if (!item.isDel) {
        buff['total'] += 1;
        if (item.country === 'Korea, Republic of') buff['korean'] += 1;
        else buff['international'] += 1;
      }
    });

    return buff;
  }

  // 국가별
  getCountryData(d) {
    let buff = [];
    for (let i = 0; i < CountryList.length; i++) {
      buff.push({
        name: CountryList[i].name,
        count: 0,
      });
    }

    if (d) {
      for (let i = 0; i < d.length; i++) {
        if (!d[i].isDel) {
          for (let j = 0; j < buff.length; j++) {
            if (buff[j].name === d[i].country) {
              buff[j].count += 1;
            }
          }
        }
      }
    }

    console.log(buff);

    return buff;
    // this.setState({country: buff});
  }

  // 회원구분별
  getMemberData = (d) => {
    let buff = cloneDeep(this.state.byMemberKind);
    //개원의, 개인병원_봉직의, 수련병원_봉직의, 기타종합병원_봉직의, 군의관_공보의, 전공의, 국내연수 외국인의사, 동반자

    //item.kind
    d.map((item) => {
      if (!item.isDel) {
        if (item.kind === '개인병원_봉직의') buff['private'] += 1;
        if (item.kind === '수련병원_봉직의') buff['trainee'] += 1;
        if (item.kind === '기타종합병원_봉직의') buff['general'] += 1;
        if (item.kind === '개원의') buff['opening'] += 1;
        if (item.kind === '군의관_공보의') buff['surgeon'] += 1;
        if (item.kind === '전공의') buff['resident'] += 1;
        if (item.kind === '국내연수 외국인의사') buff['foreigner'] += 1;
        if (item.kind === '동반자') buff['partner'] += 1;
      }
    });

    return buff;
  };

  renderCountChart() {
    const { count } = this.state;
    return (
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>총합계</TableCell>
            <TableCell>국내</TableCell>
            <TableCell>국외</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell>{count['total']}</TableCell>
            <TableCell>{count['korean']}</TableCell>
            <TableCell>{count['international']}</TableCell>
          </TableRow>
        </TableBody>
      </Table>
    );
  }

  renderMemberKindChart() {
    const { byMemberKind } = this.state;
    return (
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>개인병원 봉직의</TableCell>
            <TableCell>수련병원 봉직의</TableCell>
            <TableCell>기타종합병원 봉직의</TableCell>
            <TableCell>개원의</TableCell>
            <TableCell>군의관, 공보의</TableCell>
            <TableCell>전공의</TableCell>
            <TableCell>국내연수 외국인의사</TableCell>
            <TableCell>동반자</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell>{byMemberKind['private']}</TableCell>
            <TableCell>{byMemberKind['trainee']}</TableCell>
            <TableCell>{byMemberKind['general']}</TableCell>
            <TableCell>{byMemberKind['opening']}</TableCell>
            <TableCell>{byMemberKind['surgeon']}</TableCell>
            <TableCell>{byMemberKind['resident']}</TableCell>
            <TableCell>{byMemberKind['foreigner']}</TableCell>
            <TableCell>{byMemberKind['partner']}</TableCell>
          </TableRow>
        </TableBody>
      </Table>
    );
  }

  renderCountryChart() {
    const { byCountry } = this.state;
    return (
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>국가</TableCell>
            <TableCell>인원</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {byCountry &&
            byCountry.map(
              (country) =>
                country.count > 0 && (
                  <TableRow key={country.name}>
                    <TableCell>{country.name}</TableCell>
                    <TableCell>{country.count}</TableCell>
                  </TableRow>
                ),
            )}
        </TableBody>
      </Table>
    );
  }

  render() {
    const { classes } = this.props;
    const { count, byMemberKind, byCountry } = this.state;
    return (
      <Grid item xs={12}>
        <CssBaseline />
        <AdminTopbar MIdx={6} SIdx={0} />
        <Grid container alignItems={'stretch'} direction="column" style={{ padding: 16 }} className={classes.root}>
          <Grid item>
            <Grid container spacing={4} justifyContent={'flex-start'} alignItems={'center'}>
              <Grid item>
                <h1>Status - Sign-up</h1>
              </Grid>
            </Grid>
          </Grid>
          <Grid item>
            <SubTitle isDecoHidden={true}>총 등록자 수</SubTitle>
            {count && this.renderCountChart()}
          </Grid>
          <Grid item>
            <SubTitle isDecoHidden={true}>회원구분별 통계 (국내)</SubTitle>
            {byMemberKind && this.renderMemberKindChart()}
          </Grid>
          <Grid item>
            <SubTitle isDecoHidden={true}>국가별 통계</SubTitle>
            {byCountry && this.renderCountryChart()}
          </Grid>
        </Grid>
        <AdminFooter />
      </Grid>
    );
  }
}

export default withStyles(styles, { withTheme: true })(MemberStatusTemp);
